/* eslint-disable react/no-array-index-key */
/*
* Features:
* - PageSize: ISO page size or WIDTHxHEIGHT
* - Custom page padding
* - Utils: pt(), mm()
* - Block
* - Page divider
* - Section: Page header
* - Section: Page footer
* - Section: Page number on page footer
* - Table
*
* Features road map:
* - Pages count
* - Text block
* - Page: horizontal
* */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import P from 'prop-types';
import { THEME } from '@miotech/picasso';

import ErrorDisplay from './ErrorDisplay';
import Section from './Section';
import NewPage from './NewPage';
import Table from './Table';

import { getNodes } from './utils';

function PaperReport({
  pageSize = 'A4',
  backgroundColor = THEME.background,
  children = [],
  reportPagePadding = '20.8 14 19 14',
}) {
  const [reportPagesCount, setReportPagesCount] = useState(0);

  const getInitialSections = () => {
    const vSections: any = {};
    getNodes(children).forEach((_el: any, key: any) => {
      vSections[key] = { pages: 0, sectionStartPageNumber: 0 };
    });
    return vSections;
  };
  const [sections, setSections] = useState(getInitialSections());

  useEffect(() => {
    setReportPagesCount(_.sumBy(_.toArray(sections), s => s.pages));
  }, [sections]);

  useEffect(() => {
    setSections(getInitialSections());
  // eslint-disable-next-line
  }, [children]);

  return (
    <div style={{ backgroundColor }}>
      {getNodes(children).map((el: any, key: any) => (
          React.cloneElement(el, {
            pageSize,
            reportPagePadding,
            key: `section_${key}`,
            reportPagesCount,
            sectionStartPageNumber: sections[key].sectionStartPageNumber,
            updatePagesCount: (pages: any) => {
              setSections((state: any) => {
                const vSections = { ...state };
                let sum = 0;
                _.forEach(vSections, (s, sIndex) => { // s for section
                  const vSection = s;
                  vSection.sectionStartPageNumber = sum;
                  // eslint-disable-next-line eqeqeq
                  if (sIndex == key) {
                    vSection.pages = pages;
                  } else {
                    sum += s.pages;
                  }
                });
                return vSections;
              });
            },
          })
        ))}
    </div>
  );
}

PaperReport.propTypes = {
  pageSize: P.string,
  backgroundColor: P.string,
  children: P.any.isRequired,
  reportPagePadding: P.string,
};

PaperReport.defaultProps = {
  pageSize: 'A4',
  backgroundColor: THEME.background,
  reportPagePadding: '20.8 14 19 14',
};

PaperReport.ErrorDisplay = ErrorDisplay;
PaperReport.Section = Section;
PaperReport.NewPage = NewPage;
PaperReport.Table = Table;

export default PaperReport;
